const CDN_URL = "https://vendor-media-assets.swiggy.com/static-assets/others/"

export const TERMS_AND_CONDITIONS_PDF_URL = CDN_URL + "neocap_terms_of_use_18_09_2025.pdf"
export const PRIVACY_POLICY_PDF_URL = CDN_URL + "neocap_privacy_notice_18_09_2025.pdf"
